module.exports = __webpack_public_path__ + "static/img/application8-2.6b30c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application8-2.jpg
// module id = v8Sf
// module chunks = 0